import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'; // 만약 에러가 나면 이 줄을 지우거나 index.css 파일을 만드세요.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);